import { render, staticRenderFns } from "./AddInfo.vue?vue&type=template&id=15b538c2&scoped=true"
import script from "./AddInfo.vue?vue&type=script&lang=js"
export * from "./AddInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b538c2",
  null
  
)

export default component.exports